import { toast, ToastOptions, UpdateOptions } from 'react-toastify';
import { v4 } from 'uuid';

import NotificationComponent from './Notification.component';
import { NotificationProps } from './types';

export const notify = (notificationProps?: NotificationProps) => {
  const notificationId = String(notificationProps?.toastId ?? v4());

  if (window._disablePushNotifications) return;

  const options: Omit<ToastOptions, 'icon'> = {
    hideProgressBar: true,
    autoClose: window._disableNotificationsAutoClose ? false : window._pushNotificationsDelay || 5000,
    className: 'notifications',
    toastId: notificationId,
    ...notificationProps,
  };

  const updateOptions: UpdateOptions = {
    ...options,
    render: <NotificationComponent {...notificationProps} notificationId={notificationId} />,
  };

  if (document.getElementById(notificationId)) {
    toast.update(notificationId, updateOptions);
    return;
  }

  toast(<NotificationComponent {...notificationProps} notificationId={notificationId} />, options);
};

const useNotification = () => ({ notify });

export default useNotification;
